import { Component } from '@angular/core'

@Component({
  selector: 'se-po-email-docs',
  templateUrl: './email-docs.component.html',
  styleUrls: ['./email-docs.component.scss'],
  standalone: false,
})
export class EmailDocsComponent {
}
